export const HELPCENTER_URL = '/helpcenter/v2/helpcenter';
